import { atom } from "recoil";

const levelOfMomentAtom = atom({
  key: "levelOfMomentState",
  default: "",
});

export default levelOfMomentAtom;
